import { isExpectedUserError } from "./sentryReporting.js";

// Ids, a short code, an HTTP status, or an exception name. Form answers,
// tokens and emails must not reach LaunchError, its console log, or Sentry.
const SAFE_CONTEXT_KEYS = [
  "integrationID",
  "pageID",
  "adAccountID",
  "platform",
];

const SAFE_CODE = /^[A-Za-z0-9_.:-]{1,80}$/;
const SAFE_ERROR_NAME = /^[A-Za-z][A-Za-z0-9]{0,63}$/;
const CREATE_LEAD_FORM_FAILED_CODE = "createLeadFormFailed";

export const sanitizeCreateLeadFormCode = (code) => {
  const value =
    typeof code === "number" && Number.isFinite(code)
      ? String(code)
      : typeof code === "string"
        ? code.trim()
        : "";

  if (!SAFE_CODE.test(value)) return CREATE_LEAD_FORM_FAILED_CODE;
  return value;
};

export const getCreateLeadFormFailureCode = ({ data, error } = {}) =>
  data?.code || error?.response?.data?.code || error?.code;

export const isExpectedCreateLeadFormResult = (code) =>
  isExpectedUserError({ code });

export const buildCreateLeadFormSentryContext = ({
  context,
  code,
  status,
  errorName,
} = {}) => {
  const safeContext = {};

  SAFE_CONTEXT_KEYS.forEach((key) => {
    const value = context?.[key];
    if (typeof value === "string" || typeof value === "number") {
      safeContext[key] = value;
    }
  });

  safeContext.code = sanitizeCreateLeadFormCode(code);
  if (typeof status === "number" && Number.isFinite(status)) {
    safeContext.status = status;
  } else if (SAFE_ERROR_NAME.test(errorName || "")) {
    safeContext.name = errorName;
  }
  return safeContext;
};

export const reportCreateLeadFormAdsCampaignsFailure = ({
  dispatch,
  launchError,
  functionName,
  action,
  code,
  context,
  fromException = false,
  status,
  errorName,
}) => {
  if (!fromException && isExpectedCreateLeadFormResult(code)) return;

  const safeContext = buildCreateLeadFormSentryContext({
    context,
    code,
    status: fromException ? status : undefined,
    errorName: fromException ? errorName : undefined,
  });
  const error = new Error(
    `createLeadFormAdsCampaigns failed code=${safeContext.code}`
  );
  error.code = safeContext.code;

  dispatch(
    launchError(error, false, [], {
      functionName,
      context: safeContext,
      tags: { action },
      level: "error",
    })
  );
};
